import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function ImpersonatePage() {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get('token');
        const userData = searchParams.get('user');
        if (token) {
            // Use sessionStorage so the admin's localStorage is untouched
            sessionStorage.setItem('bgpr_token', token);
            sessionStorage.setItem('bgpr_impersonating', 'true');
            if (userData) {
                try { sessionStorage.setItem('bgpr_user', userData); } catch {}
            }
            window.location.href = '/portal';
        }
    }, [searchParams]);

    return null;
}
